import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from '../material-module/material.module';
import { PipeModule } from '../pipe/pipe.module';
import { AdminRoutingModule } from './admin-routing.module';
import { ComuniModule } from './comuni/comuni.module';
import { GruppiModule } from './gruppi/gruppi.module';
import { StatiIncaricoModule } from './stati-incarico/stati-incarico.module';
import { StatiVideoperiziaModule } from './stati-videoperizia/stati-videoperizia.module';
import { StudiModule } from './studi/studi.module';
import { RamiModule } from './rami/rami.module';
import { UsersModule } from './users/users.module';
import { TipiTemplateModule } from './tipi-template/tipi-template.module';
import { TemplatesModule } from './templates/templates.module';
import { StatiRiparazioneModule } from './stati-riparazione/stati-riparazione.module';
import { SegnalibriModule } from './segnalibri/segnalibri.module';
import { CollegamentiModule } from './collegamenti/collegamenti.module';
import { SuggerimentiModule } from './suggerimenti/suggerimenti.module';
import { ZoneGeograficheModule } from './zone-geografiche/zone-geografiche.module';
import { TipiAltroSoggettoModule } from './tipi-altro-soggetto/tipi-altro-soggetto.module';
import { GruppiRamiModule } from './gruppi-rami/gruppi-rami.module';
import { GruppiTipiDannoModule } from './gruppi-tipi-danno/gruppi-tipi-danno.module';
import { EstensioniModule } from './estensioni/estensioni.module';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { FilialiModule } from './filiali/filiali.module';
import { AnnunciModule } from './annunci/annunci.module';
import { DisposizioniCompagnieModule } from './disposizioni-compagnie/disposizioni-compagnie.module';
import { WorkflowStepsModule } from './workflow-steps/workflow-steps.module';
import { PreferenzeAgenzieModule } from './preferenze-agenzie/preferenze-agenzie.module';
import { PreferenzeAmministratoriModule } from './preferenze-amministratori/preferenze-amministratori.module';

@NgModule({
  declarations: [
    AdminPanelComponent,
  ],
  exports: [AdminPanelComponent,
    AdminRoutingModule],
  imports: [
    CommonModule,
    AdminRoutingModule,
    UsersModule,
    ComuniModule,
    CustomMaterialModule,
    PipeModule,
    ReactiveFormsModule,
    FormsModule,
    StatiIncaricoModule,
    RamiModule,
    StudiModule,
    GruppiModule,
    TipiTemplateModule,
    TemplatesModule,
    StatiVideoperiziaModule,
    StatiRiparazioneModule,
    SegnalibriModule,
    TipiAltroSoggettoModule,
    CollegamentiModule,
    SuggerimentiModule,
    ZoneGeograficheModule,
    GruppiRamiModule,
    GruppiTipiDannoModule,
    EstensioniModule,
    FilialiModule,
    AnnunciModule,
    DisposizioniCompagnieModule,
    WorkflowStepsModule,
    PreferenzeAgenzieModule,
    PreferenzeAmministratoriModule
  ],

})
export class AdminModule { }
